<template>
    <span class="search-length">{{ message }}</span>
</template>

<script>
    export default {
        props: ['initMessage'],
        data: function () {
            return {
                message: this.initMessage
            }
        },
        methods: {
            updateMessage: function(newMessage) {
                this.message = newMessage;
            }
        }
    }
</script>
